import {
  createFileRoute,
  lazyRouteComponent,
  notFound,
} from "@tanstack/react-router";

import { devShellSearchSchema } from "@/modules/dev/registry/shellSearch";
import { getMode, MODE } from "@/modules/shared/utils/env-mode";

// The shell and every preview load lazily, so production bundles carry only
// these route stubs; the gate below runs before any chunk loads.
export const Route = createFileRoute("/dev")({
  validateSearch: devShellSearchSchema,
  beforeLoad: () => {
    if (getMode() === MODE.PRODUCTION) {
      throw notFound();
    }
  },
  component: lazyRouteComponent(
    () => import("@/modules/dev/layouts/DevShell"),
    "DevShell",
  ),
});
